var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rulesign"}},[_c('h2',{staticClass:"title"},[_c('a',{staticClass:"prev",on:{"click":_vm.back}}),_vm._v("\n    积分规则\n  ")]),_vm._v(" "),_c('div',{staticClass:"rule",domProps:{"innerHTML":_vm._s(_vm.textData)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5d33290","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/RuleSign.vue
// module id = null
// module chunks = 